<template>
  <div class="container-fluid bg-white container-fluid px-4 py-4 rounded-4 contenedor-principal">
    <navegar-atras ruta="/soporte"></navegar-atras>
    <div class="row w-100">
      <ticket-detail :id="id" :es-backoffice="false"
        @ver-detalle-operacion="handleVerDetalleOperacion"
        @ver-detalle-borrador="handleVerDetalleBorrador"></ticket-detail>
    </div>
  </div>
</template>

<script setup lang="ts">
import NavegarAtras from "@/components/NavegarAtras.vue";
import TicketDetail from "@/.shared/components/soporte/TicketDetail.vue";
import { mostrarDetalleBorrador, mostrarDetalleOperacion } from "@/services/OperacionDetalleModalFactory";
import { EntidadTicketEnum } from "@/.shared/components/soporte/models/EntidadTicketEnum";
import type { DetailTicketModel } from "@api/api";

const props = defineProps({
  id: {
    type: String,
    required: true
  },
})

const handleVerDetalleOperacion = async (model: DetailTicketModel) => {
  const referencia = model.EntidadesAsociadas[EntidadTicketEnum.Operacion]?.[0];
  if (!referencia) return;

  const [idOperacion, tipoOperacion] = referencia.split("?tipo=");
  await mostrarDetalleOperacion(idOperacion, tipoOperacion as "ENERGIA" | "AGUA");
};

const handleVerDetalleBorrador = async (model: DetailTicketModel) => {
  const referencia = model.EntidadesAsociadas[EntidadTicketEnum.Borrador]?.[0];
  if (!referencia) return;

  const idBorrador = referencia.split("?tipo=")[0];
  await mostrarDetalleBorrador(idBorrador);
};

</script>
